module Meevo.Plugins.AlertsManager {
    enum EAppointmentHasBeenCanceledActionTypeEnum {
        CanceledByMeevoUser = 1,
        CanceledByClient = 2
    }

    class AppointmentHasBeenCanceled extends BaseConfigComponent implements ng.IComponentController{
        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ]

        public params: IParams;
        public data;

        public alertType:  EAppointmentHasBeenCanceledActionTypeEnum = EAppointmentHasBeenCanceledActionTypeEnum.CanceledByMeevoUser;
        public alertTypes = EAppointmentHasBeenCanceledActionTypeEnum;

        get dataForReview() {
            if (!this.alertType) return [];

            return this.alertType === EAppointmentHasBeenCanceledActionTypeEnum.CanceledByMeevoUser
                ? [this.$translate.instant('LABEL_CANCELED_BY_MEEVO_USER')]
                : [this.$translate.instant('LABEL_CANCELED_BY_CLIENT')];
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: this.alertType
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: angular.translate.ITranslateService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: Object): void {
            this.alertType = alertJSON[this.data.configKey];
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAppointmentHasBeenCanceledConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/appointment-has-been-canceled/appointment-has-been-canceled-config.html',
            controller: AppointmentHasBeenCanceled,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        })
}